var map = {
	"./barberia_black.png": 9099,
	"./cindy_black.png": 724,
	"./destinico_black.png": 7439,
	"./dunk_party_black.png": 7582,
	"./grupo3_black.png": 6297,
	"./herreria_black.png": 7633,
	"./kbza_black.png": 1735,
	"./lave_ya_black.png": 4964,
	"./oficina_sosa_black.png": 6771,
	"./pascubake_black.png": 1364,
	"./pastasroma_black.png": 5424,
	"./proplast_black.png": 9920,
	"./punto_sano_black.png": 6895,
	"./supervero_black.png": 8332,
	"./the_king_black.png": 8174,
	"./tirapu_black.png": 8172,
	"./wiki_black.png": 2787,
	"./yinyin_black.png": 2911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3147;